import { HuoChaiRenDevices, JingTaiV2Devices } from '@hid/define/define'
import { DevicePid } from './define'
import { JingTaiV2DeviceList, JingTaiMer68Devices, JingTaiMg75Devices, RoYuanDeviceList } from './device_vendor'
// dks的行程定义单位是M

const ruyuanDKSTravels = [7, 32, 32, 7]

const deviceDKSTravels: Map<DevicePid, number[]> = new Map([
  [DevicePid.IYXMu68Pro, [14, 40, 40, 14]],
  [DevicePid.IYXMu68Pro_cyan, [14, 36, 36, 14]],
  [DevicePid.IYXMu68_ULTRA, [14, 35, 35, 14]],
  [DevicePid.IROKNa87Pro, [14, 40, 40, 14]],
  [DevicePid.IROKNd63, [14, 40, 40, 14]],
  [DevicePid.IROKNd63_cyan, [14, 36, 36, 14]],
  [DevicePid.IYXPolar75, [14, 30, 30, 14]],
])
RoYuanDeviceList.forEach((v: DevicePid) => deviceDKSTravels.set(v, ruyuanDKSTravels))
JingTaiMer68Devices.forEach((v: DevicePid) => deviceDKSTravels.set(v, [14, 30, 30, 14]))
JingTaiMg75Devices.forEach((v: DevicePid) => deviceDKSTravels.set(v, [14, 30, 30, 14]))
JingTaiV2Devices.forEach((v: DevicePid) => deviceDKSTravels.set(v, [14, 30, 30, 14]))
HuoChaiRenDevices.forEach((v: DevicePid) => deviceDKSTravels.set(v, [16, 30, 30, 16]))

const ruyuanTravelLimits = [5, 25]
const deviceDKSTravelLimits: Map<DevicePid, number[]> = new Map([
  [DevicePid.IYXMu68Pro, [1, 40]],
  [DevicePid.IYXMu68Pro_cyan, [1, 36]],
  [DevicePid.IYXMu68_ULTRA, [1, 35]],
  [DevicePid.IROKNa87Pro, [1, 40]],
  [DevicePid.IROKNd63, [1, 40]],
  [DevicePid.IROKNd63_cyan, [1, 36]],
  [DevicePid.IYXPolar75, [0.01, 33]],
])
RoYuanDeviceList.forEach((v: DevicePid) => deviceDKSTravelLimits.set(v, ruyuanTravelLimits))
JingTaiMer68Devices.forEach((v: DevicePid) => deviceDKSTravelLimits.set(v, [0.04, 35]))
JingTaiMg75Devices.forEach((v: DevicePid) => deviceDKSTravelLimits.set(v, [0.05, 35]))
JingTaiV2DeviceList.forEach((v: DevicePid) => deviceDKSTravelLimits.set(v, [0.01, 33]))
HuoChaiRenDevices.forEach((v: DevicePid) => deviceDKSTravelLimits.set(v, [6, 32]))

export const deviceDKSTravel = (pid: DevicePid) => {
  const travel = deviceDKSTravels.get(pid)
  if (travel) {
    return travel
  }
  const defaultTravel = [15, 36, 36, 15]
  return defaultTravel
}

export const deviceDKSTravelLimit = (pid: DevicePid) => {
  const travelLimit = deviceDKSTravelLimits.get(pid)
  if (travelLimit) {
    return travelLimit
  }
  const defaultTravelLimit = [1, 36]
  return defaultTravelLimit
}
